import { ISideNavItem } from 'app-template-lib/utils';
import { IRoute } from 'app-template-lib/utils';
import { MainBase } from 'app-template-lib/utils';
import { ISideNavUser } from 'app-template-lib/utils';
import { IFeature } from 'app-template-lib/utils';
import { TContentsContentParams, TContentsHeaderParams } from '../shared/t-contents-params';
import { routeItems } from './route-items';
import 'app-template-lib/dist/style.css';
import React from 'react';

/**
 * Main クラス
 */
export class Main extends MainBase<TContentsHeaderParams, TContentsContentParams> {
    /**
     * React Router のルートを取得します。
     */
    getRoutes: IRoute<TContentsHeaderParams, TContentsContentParams>[] = routeItems;

    /**
     * サイドナビゲーションを取得します。
     */
    getSideNavs: ISideNavItem[] = [];

    /**
     * サイドユーザー情報を取得します。
     */
    getSideUser: ISideNavUser | null = null;

    /**
     * トップアクションを取得します。
     */
    getTopActions: React.ReactNode[] = [];

    /**
     * プロバイダーを取得します。
     */
    getProviders: React.ReactElement[] = [];

    /**
     * Featuerを初期化します。
     * @param featuers
     */
    initializeFeatuers(featuers: IFeature<TContentsHeaderParams, TContentsContentParams>[]) {
        featuers.map((f) => f.init());
    }

    /**
     * Featuerを登録して、ナビゲーションのルーターを作成します。
     * @param featuers
     * @returns
     */
    createRouter(featuers: IFeature<TContentsHeaderParams, TContentsContentParams>[]) {
        const routes = this.getRoutes; //Main のルーターを取得

        featuers.forEach((f: IFeature<TContentsHeaderParams, TContentsContentParams>) =>
            f.getRoutes.forEach((r) => {
                const route = routes.find((rf) => rf.id === r.id);
                if (!route) routes.push(r);
            })
        );
        return routes;
    }

    /**
     * Featuerを登録して、サイドナビゲーションを作成します。
     * @param featuers
     * @returns
     */
    createSideNav(featuers: IFeature<TContentsHeaderParams, TContentsContentParams>[]) {
        if (featuers.length === 0) return null;
        return null;
    }

    /**
     * Featuerを登録して、トップアクションを作成します。
     * @param featuers
     * @returns
     */
    createTopAction(featuers: IFeature<TContentsHeaderParams, TContentsContentParams>[]) {
        const topActions = this.getTopActions;
        featuers.forEach((f: IFeature<TContentsHeaderParams, TContentsContentParams>) =>
            f.getTopActions.forEach((r) => topActions.push(r))
        );
        return topActions;
    }

    /**
     * Featuerを登録して、コンテキストを作成します。
     * @param featuers
     */
    createProviderTree(featuers: IFeature<TContentsHeaderParams, TContentsContentParams>[]) {
        const providers = this.getProviders;
        featuers.forEach((f: IFeature<TContentsHeaderParams, TContentsContentParams>) => f.getProviders.forEach((r) => providers.push(r)));
        return providers;
    }
}
